import {
  PASSWORD_RESET_STATUS,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED,
  CLEAR_PASSWORD,
} from '../actions/action-types'

const initialState = {
  code: -1,
  message: '',
  temporaryPassword: '',
  reset: false,
}

// eslint-disable-next-line default-param-last
const password = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSWORD_FAILED:
      return {
        code: action.error.code,
        description: action.error.message,
      }
    case SET_PASSWORD_SUCCESS:
      return {
        code: 0,
        description: 'OK',
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        temporaryPassword: action.password,
        reset: true,
      }

    case CLEAR_PASSWORD:
    case RESET_PASSWORD_FAILED:
    case PASSWORD_RESET_STATUS:
      return initialState
    default:
      return state
  }
}

export default password
